import React from "react";

// Teepa Snow GEMS dementia-staging gemstones, drawn as small faceted-gem SVGs
// (Pearl is rendered as a lustrous round bead). Self-contained — no image assets.
const GEMS = {
  Sapphire: { crown: "#5488d8", pav: "#18509f", stroke: "#123b78" },
  Diamond: { crown: "#ecfbff", pav: "#a9d8ec", stroke: "#6ba6c4" },
  Emerald: { crown: "#5fce90", pav: "#148048", stroke: "#0e5c34" },
  Amber: { crown: "#f4bf61", pav: "#c67d15", stroke: "#96600f" },
  Ruby: { crown: "#e56b7e", pav: "#b31f37", stroke: "#7f1626" },
  Pearl: { crown: "#fffdf7", pav: "#e4d9c4", stroke: "#c3b49a" },
};

export default function GemIcon({ type, size = 15 }) {
  const g = GEMS[type];
  if (!g) return null;
  const facet = "rgba(0,0,0,.18)";

  if (type === "Pearl") {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ display: "block", flex: "none" }}>
        <circle cx="12" cy="12" r="8.6" fill={g.pav} stroke={g.stroke} strokeWidth="0.8" />
        <circle cx="9.4" cy="9.4" r="4.3" fill={g.crown} opacity="0.75" />
        <circle cx="8.5" cy="8.5" r="1.7" fill="#ffffff" opacity="0.9" />
      </svg>
    );
  }

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ display: "block", flex: "none" }}>
      <polygon points="3,10 21,10 12,21.5" fill={g.pav} />
      <polygon points="7,4 17,4 21,10 3,10" fill={g.crown} />
      <polygon points="7,4 17,4 21,10 12,21.5 3,10" fill="none" stroke={g.stroke} strokeWidth="0.9" strokeLinejoin="round" />
      <g stroke={facet} strokeWidth="0.7">
        <line x1="3" y1="10" x2="21" y2="10" />
        <line x1="7" y1="4" x2="9.5" y2="10" />
        <line x1="17" y1="4" x2="14.5" y2="10" />
        <line x1="9.5" y1="10" x2="12" y2="21.5" />
        <line x1="14.5" y1="10" x2="12" y2="21.5" />
      </g>
    </svg>
  );
}
